// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TvColDefVisEnum;
(function (TvColDefVisEnum) {
    TvColDefVisEnum[TvColDefVisEnum["Visible"] = 0] = "Visible";
    TvColDefVisEnum[TvColDefVisEnum["Hidden"] = 1] = "Hidden";
})(TvColDefVisEnum || (TvColDefVisEnum = {}));
